export function Load ()
{
	return {};
}